import { IRefIds } from 'constants/refs';
import { del, get, put } from 'services/request';
import { BaseModel, IModelOptions } from './BaseModel';

export interface IUnifiedTranslationProject {
  id: number;
  name: string;
  courseName: string;
  courseId: number;
  ref: number;
  refName: string;
  n: number;
  toDialect: string;
  createAt: string;
  freelance: string;
  priority: number;
  is_validated: boolean | null;
  async_task_status: number;
}

export default class TranslationUnifiedProjectModel extends BaseModel<IUnifiedTranslationProject> {
  private dialectId = 0;
  private languageId = 0;

  constructor(options: IModelOptions) {
    super(options);
    this.ref = IRefIds.translationUnified;
    this.gridName = 'TranslationUnifiedProjects';
    this.getGridColumns();
  }

  getCourseId(): number {
    return this.courseId;
  }

  async loadItemEdit(itemId?: number) {
    // Set courseId from grid data so CAT link works
    if (itemId !== undefined) {
      const row = this.gridData.find((r) => r.id === itemId);
      if (row) {
        this.courseId = row.courseId;
      }
    }
    await super.loadItemEdit(itemId);
  }

  getDialectId(): number {
    return this.dialectId;
  }

  setDialectId(dialectId: number) {
    this.dialectId = dialectId;
  }

  setLanguageId(languageId: number) {
    this.languageId = languageId;
  }

  async getGrid() {
    if (!this.dialectId || !this.languageId) {
      return;
    }
    await super.getGrid();
    this.gridData = await get<IUnifiedTranslationProject[]>('/translation-unified/projects', {
      dialectId: this.dialectId,
      languageId: this.languageId,
    });
    this.loadingGrid = false;
    this.render();
  }

  async reload() {
    await super.reload();
    await this.getGrid();
  }

  async loadItemData(itemId: number): Promise<object> {
    return await get<object>(`translations/projects/${itemId}`);
  }

  async save() {
    await this.updateItem();
  }

  async updateItem() {
    const updated = this.itemUpdated;
    const { id } = updated;
    await put(`translations/projects/${id}`, updated);
    await this.getGrid();
  }

  async delete() {
    await super.delete();
    const { id } = this.itemUpdated;
    const result = await del(`translations/projects/${id}`);
    this.itemId = -1;
    this.hide();
    this.loadingItem = false;
    this.render();
    if (result.ok) {
      await this.getGrid();
    }
  }

  async reloadItem() {
    await this.loadItemEdit(this.itemId);
  }
}
